module.exports = __webpack_public_path__ + "static/media/emotionLight.f8307654.svg";